import React from 'react';

export default function WeddingLawnAndConferenceHall() {
  return (
  <section className="parallax-section fort-section">
        <div className="parallax-overlay"></div>
        <div className="parallax-content">
            <div className="container text-center parallax-text">
                <div className="event-section-header mb-5">
                    <h2 className="display-4 fw-bold mb-3 fade-in-scale event-title">Wedding Lawn & Conference Hall</h2>
                    <div className="event-subtitle-line"></div>
                </div>
                
                <div className="row g-4 mb-5">
                    <div className="col-lg-6 col-md-6 mb-4">
                        <div className="event-feature-card wedding-card">
                            <div className="event-icon">
                                <i className="fas fa-heart"></i>
                            </div>
                            <h4 className="event-feature-title">Wedding Lawn</h4>
                            <p className="event-feature-desc">Breathtaking outdoor venue with panoramic valley views. Perfect for intimate ceremonies and grand celebrations.</p>
                            <div className="event-features-list">
                                <span className="feature-tag">Panoramic Views</span>
                                <span className="feature-tag">Natural Beauty</span>
                                <span className="feature-tag">Flexible Capacity</span>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-lg-6 col-md-6 mb-4">
                        <div className="event-feature-card conference-card">
                            <div className="event-icon">
                                <i className="fas fa-users"></i>
                            </div>
                            <h4 className="event-feature-title">Conference Hall</h4>
                            <p className="event-feature-desc">State-of-the-art facility accommodating up to 100 guests with modern amenities and professional setup.</p>
                            <div className="event-features-list">
                                <span className="feature-tag">200+ Capacity</span>
                                <span className="feature-tag">Modern Tech</span>
                                <span className="feature-tag">Professional Setup</span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="row mb-5">
                    <div className="col-md-8 mx-auto">
                        <div className="event-highlights">
                            <div className="highlight-item">
                                <i className="fas fa-star"></i>
                                <span>Exclusive venue with stunning mountain backdrop</span>
                            </div>
                            <div className="highlight-item">
                                <i className="fas fa-star"></i>
                                <span>Professional event planning and catering services</span>
                            </div>
                            <div className="highlight-item">
                                <i className="fas fa-star"></i>
                                <span>Flexible packages for all event types</span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="event-cta-section">
                    <a href="#contact" className="btn btn-primary btn-lg event-cta-btn">
                        <i className="fas fa-calendar-check me-2"></i>Book Your Event
                    </a>
                    <a href="#contact" className="btn btn-outline-light btn-lg event-cta-btn ms-3">
                        <i className="fas fa-info-circle me-2"></i>Learn More
                    </a>
                </div>
            </div>
        </div>
    </section>
      )
}
